/**
 * Scroll the matching side-panel section into view + focus its
 * control. Keys match the `data-side-section` attribute set on each
 * Section in TicketDetail's right-hand aside.
 *
 * Used by:
 *   - Composer toolbar buttons (Log time / Change status / Assign)
 *   - e/a/s/t keyboard shortcuts on the ticket detail
 *
 * Silent no-op if the element isn't mounted (e.g., portal mode where
 * the staff side-panel doesn't render).
 */

export type SidePanelSectionKey = 'hours' | 'status' | 'assignee' | 'priority';

export function focusSidePanelSection(key: SidePanelSectionKey): void {
  const el = document.querySelector<HTMLElement>(
    `[data-side-section="${key}"]`
  );
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  const focusable = el.querySelector<HTMLElement>(
    'button, [tabindex]:not([tabindex="-1"]), input, select'
  );
  focusable?.focus();
}
